import styled from 'styled-components';

export const Container = styled.div`
  padding: 3rem 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1rem 0.85rem 2.75rem;
  }
`;

export const Header = styled.div`
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    margin-bottom: 1.25rem;
  }
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.blue9};
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.55rem;
    margin-bottom: 0.45rem;
  }
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 0.82rem;
    line-height: 1.35;
    margin-bottom: 0.9rem;
    max-width: 24rem;
  }
`;

export const FilterBar = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const FilterButton = styled.button<{ active?: boolean }>`
  background: ${({ theme, active }) => active ? theme.colors.blue4 : theme.colors.blue3};
  color: ${({ theme }) => theme.colors.blue9};
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
      font-family: 'Poppins', sans-serif;

  &:hover {
    background: ${({ theme }) => theme.colors.blue4};
  }
`;

export const MobileFilterGroup = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: grid;
    gap: 0.35rem;
  }
`;

export const MobileFilterLabel = styled.label`
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 0.72rem;
  font-weight: 700;
`;

export const MobileFilterSelect = styled.select`
  width: 100%;
  min-height: 44px;
  appearance: none;
  background:
    linear-gradient(45deg, transparent 50%, ${({ theme }) => theme.colors.blue10} 50%) right 0.85rem center / 5px 5px no-repeat,
    linear-gradient(135deg, ${({ theme }) => theme.colors.blue2}, ${({ theme }) => theme.colors.blue3});
  border: 1px solid ${({ theme }) => theme.colors.blue4};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.blue9};
  font-family: 'Poppins', sans-serif;
  font-size: 0.86rem;
  font-weight: 700;
  padding: 0.7rem 1.75rem 0.7rem 0.8rem;
`;

export const FeaturedPost = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.blue2};
  border: 1px solid ${({ theme }) => theme.colors.blue3};
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 3rem;
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-4px);
    border-color: ${({ theme }) => theme.colors.blue4};
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    border-color: ${({ theme }) => theme.colors.blue5};
    border-radius: 12px;
    margin-bottom: 1.25rem;
    box-shadow: 0 18px 44px rgba(0, 0, 0, 0.18);
  }
`;

export const FeaturedImage = styled.div`
  position: relative;
  aspect-ratio: 16/9;
  background-size: cover;
  background-position: center;
  background-color: ${({ theme }) => theme.colors.blue3};

  @media (max-width: 768px) {
    aspect-ratio: 16 / 9;
  }
`;

export const FeaturedContent = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 1rem;

    button {
      margin-top: 0.9rem !important;
      padding: 0.65rem 0.9rem;
      font-size: 0.8rem;
    }
  }
`;

export const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.7rem;
    margin-bottom: 2rem;
  }
`;

export const BlogCard = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.blue2};
  border: 1px solid ${({ theme }) => theme.colors.blue3};
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    border-color: ${({ theme }) => theme.colors.blue4};
  }

  @media (max-width: 768px) {
    border-radius: 10px;
  }
`;

export const BlogImage = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  background-size: cover;
  background-position: center;
  background-color: ${({ theme }) => theme.colors.blue3};

  @media (max-width: 768px) {
    aspect-ratio: 4 / 3;
  }
`;

export const BlogContent = styled.div`
  padding: 1.5rem;

  @media (max-width: 768px) {
    padding: 0.65rem;
  }
`;

export const CategoryBadge = styled.span`
  background: ${({ theme }) => theme.colors.blue4};
  color: ${({ theme }) => theme.colors.blue9};
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    border-radius: 4px;
    font-size: 0.58rem;
    line-height: 1.1;
    margin-bottom: 0.45rem;
    max-width: 100%;
    overflow: hidden;
    padding: 0.22rem 0.42rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const PostTitle = styled.h2`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.blue9};
  margin-bottom: 0.75rem;
  font-weight: 600;
  line-height: 1.3;

  ${FeaturedPost} & {
    @media (max-width: 768px) {
      font-size: 1.12rem;
      line-height: 1.25;
      margin-bottom: 0.7rem;
    }
  }

  @media (max-width: 768px) {
    font-size: 0.86rem;
    line-height: 1.2;
    margin-bottom: 0.65rem;
  }
`;

export const PostExcerpt = styled.p`
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;

  ${FeaturedPost} & {
    @media (max-width: 768px) {
      display: -webkit-box;
      font-size: 0.78rem;
      line-height: 1.35;
      margin-bottom: 0.75rem;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const PostMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 0.85rem;

  @media (max-width: 768px) {
    gap: 0.35rem;
    font-size: 0.62rem;
    line-height: 1.2;
    margin-top: 0.15rem;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  color: ${({ theme }) => theme.colors.blue11};
  font-size: 1.1rem;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  min-height: 300px;
  color: ${({ theme }) => theme.colors.blue11};
  text-align: center;

  div {
    font-size: 1.1rem;
  }
`;

export const EmptyState = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: ${({ theme }) => theme.colors.blue11};
  text-align: center;
  font-size: 1.1rem;
`;

export const CodeBadge = styled.span`
  position: absolute;
  top: 12px;
  right: 12px;
  background: ${({ theme }) => theme.colors.blue5};
  color: ${({ theme }) => theme.colors.blue10};
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  z-index: 2; /* Keep it above other elements */
  
  i {
    font-size: 1rem;
  }

  @media (max-width: 768px) {
    top: 8px;
    right: 8px;
    font-size: 0;
    padding: 0.35rem;

    i {
      font-size: 0.85rem;
    }
  }
`;

export const FeaturedLabel = styled.div`
  position: absolute;
  left: 1rem;
  top: 1rem;
  z-index: 2;
  background: rgba(15, 17, 19, 0.78);
  border: 1px solid rgba(250, 252, 255, 0.14);
  border-radius: 999px;
  color: ${({ theme }) => theme.colors.blue9};
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  padding: 0.42rem 0.68rem;
  text-transform: uppercase;

  @media (max-width: 768px) {
    left: 0.65rem;
    top: 0.65rem;
    font-size: 0.66rem;
    padding: 0.34rem 0.52rem;
  }
`;
